import React from "react";
import {useTheme} from "@emotion/react";

import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    subtitle?: string;
    text?: string;
}
export const MarkerPopup = (props: IProps) => {
    const theme = useTheme();
    return (
        <div css={[p(2)]}>
            <Text as="div" variant="info_txt_2" strong css={[m(0)]}>
                {props.title}
            </Text>
            {props.subtitle ? (
                <Text as="div" variant="info_txt_2" color={theme.colors.gray["700"]} css={[m(0, 0, 0.5, 0)]}>
                    {props.subtitle}
                </Text>
            ) : null}
            {props.text ? (
                <Text as="div" variant="info_txt_2" css={[m(0)]}>
                    {props.text}
                </Text>
            ) : null}
        </div>
    );
};
import React from "react";
import {useTheme} from "@emotion/react";

import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

interface IProps {
    title: string;
    subtitle?: string;
    text?: string;
}
export const MarkerPopup = (props: IProps) => {
    const theme = useTheme();
    return (
        <div css={[p(2)]}>
            <Text as="div" variant="info_txt_2" strong css={[m(0)]}>
                {props.title}
            </Text>
            {props.subtitle ? (
                <Text as="div" variant="info_txt_2" color={theme.colors.gray["700"]} css={[m(0, 0, 0.5, 0)]}>
                    {props.subtitle}
                </Text>
            ) : null}
            {props.text ? (
                <Text as="div" variant="info_txt_2" css={[m(0)]}>
                    {props.text}
                </Text>
            ) : null}
        </div>
    );
};
